"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdvMediator = void 0;
const uuid_1 = require("uuid");
const enums_1 = require("../enums");
const IdvMediator_enums_1 = require("./IdvMediator.enums");
class IdvMediator {
    constructor(props) {
        this.listener = {
            permanentList: [],
            tempList: [],
        };
        this.registerHandler = (name, listener) => {
            const requestName = `${name}_${this.controllerType.opposite}`;
            const responseName = `${name}_${this.controllerType.main}`;
            if (this.listener.permanentList.some((item) => item.name === requestName)) {
                throw new Error(enums_1.ErrorType.ListenerExist);
            }
            this.listener.permanentList.push({
                name: requestName,
                responseName,
                listener,
            });
        };
        this.send = (name, data) => {
            const requestName = `${name}_${this.controllerType.main}`;
            const responseName = `${name}_${this.controllerType.opposite}`;
            const newListenerId = (0, uuid_1.v4)();
            const newListener = {
                name: responseName,
                id: newListenerId,
                resolve: null,
                reject: null,
            };
            this.listener.tempList.push(newListener);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject) => {
                newListener.resolve = resolve;
                newListener.reject = reject;
                const payload = {
                    id: newListenerId,
                    isSuccess: true,
                    data,
                };
                this.triggerEvent(requestName, payload);
            });
        };
        this.unregisterHandlers = () => {
            var _a;
            window.removeEventListener('message', this.receiveMessage, false);
            this.listener.permanentList = [];
            while (this.listener.tempList.length > 0) {
                const listener = this.listener.tempList.pop();
                (_a = listener === null || listener === void 0 ? void 0 : listener.reject) === null || _a === void 0 ? void 0 : _a.call(listener, enums_1.ErrorType.EventCancelled);
            }
        };
        this.triggerEvent = (name, payload) => {
            this.communicationWindow.postMessage({
                name,
                details: payload,
            }, '*');
        };
        this.receiveMessage = (event) => {
            const { data, origin } = event;
            if ((this.allowedOrigin && this.allowedOrigin !== origin) ||
                !data ||
                !data.name ||
                !data.details) {
                return;
            }
            const { name, details } = data;
            const tempListener = this.listener.tempList.find((item) => item.name === name && details.id === item.id);
            if (tempListener) {
                this.handleTempListenerResponse(tempListener, details);
                return;
            }
            const permanentListener = this.listener.permanentList.find((item) => item.name === name);
            if (permanentListener) {
                this.handlePermanentListenerResponse(permanentListener, details);
            }
        };
        this.handleTempListenerResponse = (listenerData, response) => {
            var _a, _b;
            const { isSuccess, data } = response;
            if (isSuccess) {
                (_a = listenerData.resolve) === null || _a === void 0 ? void 0 : _a.call(listenerData, data);
            }
            else {
                (_b = listenerData.reject) === null || _b === void 0 ? void 0 : _b.call(listenerData, data);
            }
            const index = this.listener.tempList.indexOf(listenerData);
            if (index > -1) {
                this.listener.tempList.splice(index, 1);
            }
        };
        this.handlePermanentListenerResponse = (listenerData, response) => __awaiter(this, void 0, void 0, function* () {
            const { id, data } = response;
            const result = {
                id,
                isSuccess: false,
            };
            try {
                result.data = yield listenerData.listener(data);
                result.isSuccess = true;
            }
            catch (error) {
                const errorData = error;
                result.data = (errorData === null || errorData === void 0 ? void 0 : errorData.message) || null;
            }
            this.triggerEvent(listenerData.responseName, result);
        });
        const { allowedOrigin, iframeElement, type } = props;
        const oppositeType = type === IdvMediator_enums_1.ControllerType.Parent
            ? IdvMediator_enums_1.ControllerType.Child
            : IdvMediator_enums_1.ControllerType.Parent;
        this.controllerType = {
            main: type,
            opposite: oppositeType,
        };
        this.allowedOrigin = allowedOrigin || null;
        this.communicationWindow = (iframeElement === null || iframeElement === void 0 ? void 0 : iframeElement.contentWindow) || window.parent;
        window.addEventListener('message', this.receiveMessage, false);
    }
}
exports.IdvMediator = IdvMediator;
